export default __webpack_public_path__ + "static/media/icon-x-color.7bd3a79a.svg";